import React, { useEffect,useState } from 'react';
import './faqs.scss';
import { useTranslation } from "react-i18next";
import { getLanguageFromLocalStorage,savePageTranslateLocalStorage,initializeI18n } from "../../app/utilities/localization"
const Faqs = () => {
  const { t } = useTranslation();
  const [current_languae,setCurrentLanguage] = useState("");
  const language = getLanguageFromLocalStorage();
  useEffect(() => {
    document.body.classList.add('no_scroll_class');
    return () => {
      document.body.classList.remove('no_scroll_class');
    };
  }, []);
  useEffect(() => {
    if(language==="in"){
      setCurrentLanguage('/hi/');
    } else  {
      setCurrentLanguage('');
    }
  
  }, [language]);
  useEffect(() => {
    const fetchData = async () => {
      await savePageTranslateLocalStorage("home");
      initializeI18n(['premium']);
    };

    fetchData();
  }, []);
  return (
    <div id="FaqsPage">
      <iframe
        src={`https://mohabbatein.com/${current_languae}frequently-asked-questions/?app_header=on`}
        width="100%"
        height="100%"
        frameBorder="0"
        id="faqs-page-iframe"
        title="FAQs"
      ></iframe>
    </div>
  );
};

export default Faqs;
